import { render, staticRenderFns } from "./AddPurchase.vue?vue&type=template&id=3464311c&scoped=true&"
import script from "./AddPurchase.vue?vue&type=script&lang=js&"
export * from "./AddPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchase.vue?vue&type=style&index=0&id=3464311c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3464311c",
  null
  
)

export default component.exports